import { Routes } from '@angular/router';
// import { LoginComponent } from './public/login/login.component';
import { LayoutComponent } from '../layouts/layout.component';
import { authGuard } from '../auth.gaurd';
// import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NotFoundComponent } from '../shared/not-found/not-found.component';
import { BusinessInfoComponent } from './public/business-info/business-info.component';
import { BusinessSetupProgressLoaderComponent } from './public/business-setup-progress-loader/business-setup-progress-loader.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { LoginComponent } from './public/login/login.component';
import { NewPasswordComponent } from './public/new-password/new-password.component';
import { RegisterComponent } from './public/register/register.component';
import { QuickbookCallbackComponent } from './public/quickbook-callback/quickbook-callback.component';
import { ConfirmComponent } from './public/confirm/confirm.component';
import { DebtTypeConfirmationComponent } from '../shared/debt-type-confirmation/debt-type-confirmation.component';
import { OpenOutreachComponent } from './public/open-outreach/open-outreach.component';
// import { VerifyPhoneNumberComponent } from './public/verify-phone-number/verify-phone-number.component';
// import { RegisterComponent } from './public/register/register.component';
// import { NewPasswordComponent } from './public/new-password/new-password.component';
// import { VerifyPhoneNumberComponent } from './public/verify-phone-number/verify-phone-number.component';
// import { BusinessInfoComponent } from './public/business-info/business-info.component';
// import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { ShareLinkComponent } from './public/share-link-component/share-link-component.component';

export const routes: Routes = [
    { path: '', redirectTo: 'app', pathMatch: 'full' },
    {
        path: 'app',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule),
                // canActivate: [FreezGuard],
            },
            {
                path: 'contract',
                loadChildren: () => import('./components/contract/contract.module').then(m => m.ContractModule),
                // canActivate: [FreezGuard],
            },
            {
                path: 'profile',
                loadChildren: () => import('./components/profile-layout/profile.module').then(m => m.ProfileModule),
            },
            {
                path: 'payment-list',
                loadChildren: () => import('./components/payment-list/payment-list.module').then(m => m.PaymentListModule),
            },

            {
                path: 'support',
                loadChildren: () => import('./components/support/support.module').then(m => m.SupportModule),
            },
            
            {
                path: 'manage-users',
                loadChildren: () => import('./components/manage-users/manage-users.module').then(m => m.ManageUsersModule),
            },

            {
                path: 'debt-recuvery',
                loadChildren: () => import('./components/debt-recuvery/debt-recuvery.module').then(m => m.DebtRecuveryModule)
            },
            // {
            //     path: 'debt-recuvery',
            //     loadChildren: () => import('./components/debt-recuvery-comercial/debt-recuvery-comercial.module').then(m => m.DebtRecuveryComercialModule)
            // },
            {
                path: 'e-consent',
                loadChildren: () => import('./components/e-consent/e-consent.module').then(m => m.EConsentModule)
            },
            {
                path: 'customer',
                loadChildren: () => import('./components/customer/customer.module').then(m => m.CustomerModule),
            },
            { path: 'quickbook-callback', component: QuickbookCallbackComponent },
            {
                path: 'integration',
                loadChildren: () => import('./components/quickbooks/quickbooks.module').then(m => m.QuickbooksModule),
            },
            {
                path: 'disputes',
                loadChildren: () => import('./components/disputes/disputes.module').then(m => m.DisputesModule),
            },
            { path: '404', component: NotFoundComponent },
            { path: '**', component: NotFoundComponent },
        ]
    },
    { path: 'new-password', component: NewPasswordComponent },
    { path: 'register', component: RegisterComponent },
    {path: 'debt-type-enabled', component: DebtTypeConfirmationComponent},
    { path: 'login', component: LoginComponent },
    { path: 'confirm' , component: ConfirmComponent },
    // { path: 'verify-phone-number', component: VerifyPhoneNumberComponent },
    { path: 'business-info', component: BusinessInfoComponent },
    { path: 'business-Info', component: BusinessSetupProgressLoaderComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'outreach', component: OpenOutreachComponent },
    {path: 'receipt/:token', component: ShareLinkComponent},
    { path: '**', redirectTo: 'login' },
]
